import type { IconSvgObject } from './types';

const GoogleGeminiIcon: IconSvgObject = [
  ["path", { d: "M3 12C7.97056 12 12 7.97056 12 3C12 7.97056 16.0294 12 21 12C16.0294 12 12 16.0294 12 21C12 16.0294 7.97056 12 3 12Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default GoogleGeminiIcon;
